(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cube-gps-car-product"] && !Shopify.designMode) return;
  try {
    
function initializeCubeCarProduct(root) {
  if (!root || root.cubeCarCleanup) return;
  const controller = new AbortController();
  root.addEventListener('change', event => {
    const selector = event.target.closest('[data-cc-variant]');
    if (!selector) return;
    const option = selector.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    root.querySelectorAll('[name="id"]').forEach(input => { input.value = option.value; });
    root.querySelectorAll('[name="quantity"]').forEach(input => { input.value = option.dataset.quantity || '1'; });
    root.querySelectorAll('[data-cc-price]').forEach(price => { price.textContent = option.dataset.price; });
    root.querySelectorAll('[data-cc-compare]').forEach(price => {
      price.textContent = option.dataset.compare;
      price.hidden = option.dataset.onSale !== 'true';
    });
    root.querySelectorAll('[data-cc-add]').forEach(button => {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.querySelector('[data-cc-label]').textContent = available ? 'Add to cart' : 'Sold out';
    });
    root.querySelector('[data-cc-status]').textContent = `${option.dataset.price}. ${available ? 'Available to add to cart.' : 'Sold out.'}`;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(history.state, '', url);
  }, { signal: controller.signal });
  root.cubeCarCleanup = () => { controller.abort(); delete root.cubeCarCleanup; };
}
function initializeCubeCarProducts(scope = document) {
  if (scope.matches?.('[data-cube-car-product]')) initializeCubeCarProduct(scope);
  scope.querySelectorAll('[data-cube-car-product]').forEach(initializeCubeCarProduct);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCubeCarProducts(), { once: true });
else initializeCubeCarProducts();
document.addEventListener('shopify:section:load', event => initializeCubeCarProducts(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-cube-car-product]').forEach(root => root.cubeCarCleanup?.());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cube-gps-funnel"] && !Shopify.designMode) return;
  try {
    
function initializeCubeFunnel(root) {
  if (!root || root.cubeFunnelCleanup) return;
  const controller = new AbortController();
  const signal = controller.signal;
  const toggle = root.querySelector('#' + 'cube-menu-toggle');
  const drawer = root.querySelector('#' + 'cube-mobile-menu');
  const closeButton = root.querySelector('#' + 'cube-menu-close');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!toggle || !drawer || !closeButton) return;
  let savedScrollY = 0;
  let savedBodyStyles;
  let animation;
  let closing = false;
  let destination;

  function unlockPage() {
    if (!savedBodyStyles) return;
    Object.assign(document.body.style, savedBodyStyles);
    savedBodyStyles = undefined;
    window.scrollTo(0, savedScrollY);
  }

  function goToSection(hash) {
    const section = root.querySelector('#' + hash.slice(1));
    if (!section) return;
    if (window.location.hash !== hash) history.pushState(null, '', hash);
    
    const hadTabindex = section.hasAttribute('tabindex');
    if (!hadTabindex) {
      section.setAttribute('tabindex', '-1');
      section.addEventListener('blur', () => section.removeAttribute('tabindex'), { once: true });
    }
    section.focus({ preventScroll: true });
    section.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  function openMenu() {
    if (!mobile.matches || drawer.open) return;
    destination = undefined;
    savedScrollY = window.scrollY;
    savedBodyStyles = Object.fromEntries(
      ['position', 'top', 'left', 'right', 'width', 'overflow'].map(key => [key, document.body.style[key]])
    );
    Object.assign(document.body.style, {
      position: 'fixed', top: `-${savedScrollY}px`, left: '0', right: '0', width: '100%', overflow: 'hidden'
    });
    drawer.showModal();
    toggle.setAttribute('aria-expanded', 'true');
    closeButton.focus({ preventScroll: true });
    animation = drawer.animate(
      [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }],
      { duration: reducedMotion.matches ? 0 : 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );
  }

  async function closeMenu({ immediate = false, hash } = {}) {
    if (!drawer.open || (closing && !immediate)) return;
    closing = true;
    destination = hash;
    animation?.cancel();
    if (!immediate && !reducedMotion.matches) {
      drawer.classList.add('is-closing');
      animation = drawer.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }],
        { duration: 200, easing: 'ease-in', fill: 'forwards' }
      );
      try {
        await animation.finished;
      } catch {
        return; 
      }
    }
    drawer.close();
  }

  drawer.addEventListener('close', () => {
    animation?.cancel();
    drawer.classList.remove('is-closing');
    closing = false;
    toggle.setAttribute('aria-expanded', 'false');
    unlockPage();
    if (destination) {
      goToSection(destination);
      destination = undefined;
    } else {
      const focusTarget = mobile.matches ? toggle : root.querySelector('.cube-header-logo');
      focusTarget.focus({ preventScroll: true });
    }
  }, { signal });

  toggle.addEventListener('click', openMenu, { signal });
  closeButton.addEventListener('click', () => closeMenu(), { signal });
  drawer.addEventListener('cancel', event => {
    event.preventDefault();
    closeMenu();
  }, { signal });
  drawer.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link) {
      event.preventDefault();
      closeMenu({ hash: link.hash });
      return;
    }
    const rect = drawer.getBoundingClientRect();
    const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (event.target === drawer && outside) closeMenu();
  }, { signal });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, { signal });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) closeMenu({ immediate: true });
  }, { signal });
  root.cubeFunnelCleanup = () => {
    animation?.cancel();
    if (drawer.open) drawer.close();
    unlockPage();
    toggle.setAttribute('aria-expanded', 'false');
    controller.abort();
    delete root.cubeFunnelCleanup;
  };
}

function initializeCubeFunnels() {
  document.querySelectorAll('[data-cube-gps-funnel]').forEach(initializeCubeFunnel);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCubeFunnels, { once: true });
} else {
  initializeCubeFunnels();
}
document.addEventListener('shopify:section:load', event => {
  const root = event.target.querySelector('[data-cube-gps-funnel]');
  if (root) initializeCubeFunnel(root);
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelector('[data-cube-gps-funnel]')?.cubeFunnelCleanup?.();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cube-gps-pet-product"] && !Shopify.designMode) return;
  try {
    
function initializeCubePetProduct(root) {
  if (!root || root.cubePetProductCleanup) return;
  const controller = new AbortController();
  root.addEventListener('change', event => {
    const selector = event.target.closest('[data-cube-pet-variant]');
    if (!selector) return;
    const option = selector.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    root.querySelectorAll('[name="id"]').forEach(input => { input.value = option.value; });
    root.querySelectorAll('[name="quantity"]').forEach(input => { input.value = option.dataset.quantity || '1'; });
    root.querySelectorAll('[data-cube-pet-price]').forEach(price => { price.textContent = option.dataset.price; });
    root.querySelectorAll('[data-cube-pet-add]').forEach(button => {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.querySelector('[data-cube-pet-button-label]').textContent = available ? 'Add to cart' : 'Sold out';
    });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(history.state, '', url);
  }, { signal: controller.signal });
  root.cubePetProductCleanup = () => { controller.abort(); delete root.cubePetProductCleanup; };
}
function initializeCubePetProducts(){ document.querySelectorAll('[data-cube-pet-product]').forEach(initializeCubePetProduct); }
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCubePetProducts, {once:true});
else initializeCubePetProducts();
document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-cube-pet-product]').forEach(initializeCubePetProduct); });
document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-cube-pet-product]').forEach(root => root.cubePetProductCleanup?.()); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cube-pack-track-funnel"] && !Shopify.designMode) return;
  try {
    

function initializePackTrackFunnel(root) {
  if (!root || root.packTrackFunnelCleanup) return;
  const controller = new AbortController();
  const signal = controller.signal;
  const toggle = root.querySelector('#' + 'cube-menu-toggle');
  const drawer = root.querySelector('#' + 'cube-mobile-menu');
  const closeButton = root.querySelector('#' + 'cube-menu-close');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!toggle || !drawer || !closeButton) return;
  let savedScrollY = 0;
  let savedBodyStyles;
  let animation;
  let closing = false;
  let destination;

  function unlockPage() {
    if (!savedBodyStyles) return;
    Object.assign(document.body.style, savedBodyStyles);
    savedBodyStyles = undefined;
    window.scrollTo(0, savedScrollY);
  }

  function goToSection(hash) {
    const section = root.querySelector('#' + hash.slice(1));
    if (!section) return;
    if (window.location.hash !== hash) history.pushState(null, '', hash);
    
    const hadTabindex = section.hasAttribute('tabindex');
    if (!hadTabindex) {
      section.setAttribute('tabindex', '-1');
      section.addEventListener('blur', () => section.removeAttribute('tabindex'), { once: true });
    }
    section.focus({ preventScroll: true });
    section.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  function openMenu() {
    if (!mobile.matches || drawer.open) return;
    destination = undefined;
    savedScrollY = window.scrollY;
    savedBodyStyles = Object.fromEntries(
      ['position', 'top', 'left', 'right', 'width', 'overflow'].map(key => [key, document.body.style[key]])
    );
    Object.assign(document.body.style, {
      position: 'fixed', top: `-${savedScrollY}px`, left: '0', right: '0', width: '100%', overflow: 'hidden'
    });
    drawer.showModal();
    toggle.setAttribute('aria-expanded', 'true');
    closeButton.focus({ preventScroll: true });
    animation = drawer.animate(
      [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }],
      { duration: reducedMotion.matches ? 0 : 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );
  }

  async function closeMenu({ immediate = false, hash } = {}) {
    if (!drawer.open || (closing && !immediate)) return;
    closing = true;
    destination = hash;
    animation?.cancel();
    if (!immediate && !reducedMotion.matches) {
      drawer.classList.add('is-closing');
      animation = drawer.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }],
        { duration: 200, easing: 'ease-in', fill: 'forwards' }
      );
      try {
        await animation.finished;
      } catch {
        return; 
      }
    }
    drawer.close();
  }

  drawer.addEventListener('close', () => {
    animation?.cancel();
    drawer.classList.remove('is-closing');
    closing = false;
    toggle.setAttribute('aria-expanded', 'false');
    unlockPage();
    if (destination) {
      goToSection(destination);
      destination = undefined;
    } else {
      const focusTarget = mobile.matches ? toggle : root.querySelector('.cube-header-logo');
      focusTarget.focus({ preventScroll: true });
    }
  }, { signal });

  toggle.addEventListener('click', openMenu, { signal });
  closeButton.addEventListener('click', () => closeMenu(), { signal });
  drawer.addEventListener('cancel', event => {
    event.preventDefault();
    closeMenu();
  }, { signal });
  drawer.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link) {
      event.preventDefault();
      closeMenu({ hash: link.hash });
      return;
    }
    const rect = drawer.getBoundingClientRect();
    const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (event.target === drawer && outside) closeMenu();
  }, { signal });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, { signal });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) closeMenu({ immediate: true });
  }, { signal });
  root.packTrackFunnelCleanup = () => {
    animation?.cancel();
    if (drawer.open) drawer.close();
    unlockPage();
    toggle.setAttribute('aria-expanded', 'false');
    controller.abort();
    delete root.packTrackFunnelCleanup;
  };
}

function initializePackTrackFunnels() {
  document.querySelectorAll('[data-cube-pack-track-funnel]').forEach(initializePackTrackFunnel);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePackTrackFunnels, { once: true });
} else {
  initializePackTrackFunnels();
}
document.addEventListener('shopify:section:load', event => {
  const root = event.target.querySelector('[data-cube-pack-track-funnel]');
  if (root) initializePackTrackFunnel(root);
});
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelector('[data-cube-pack-track-funnel]')?.packTrackFunnelCleanup?.();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-page-amazon-prime"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerSelector = '[data-prime-cart-trigger]';
    const closeSelector = '[data-prime-cart-close]';
    const focusableSelector = ['a[href]', 'button:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(',');
    const savedStyles = new WeakMap();

    const formatPrice = (value) => {
      const number = Number(String(value || '').replace(/[^0-9.]/g, '')) || 0;
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(number);
    };

    const closeDrawer = (drawer) => {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      const styles = savedStyles.get(drawer);
      if (styles) {
        document.body.style.overflow = styles.overflow;
        document.body.style.paddingRight = styles.paddingRight;
      }
      drawer._primeLastFocus?.focus();
    };

    const openDrawer = (trigger) => {
      const root = trigger.closest('[data-prime-flow]');
      const drawer = root?.querySelector('[data-prime-cart-drawer]');
      if (!drawer) return;
      const price = formatPrice(trigger.dataset.primePrice);
      const image = drawer.querySelector('[data-prime-cart-image]');
      drawer.querySelector('[data-prime-cart-product]').textContent = trigger.dataset.primeProduct || 'Cube GPS';
      drawer.querySelector('[data-prime-cart-description]').textContent = trigger.dataset.primeDescription || 'GPS tracker';
      drawer.querySelector('[data-prime-cart-price]').textContent = price;
      drawer.querySelector('[data-prime-cart-subtotal]').textContent = price;
      drawer.querySelector('[data-prime-cart-checkout]').href = trigger.dataset.primeCheckout || '#';
      image.src = trigger.dataset.primeImage || '';
      image.alt = trigger.dataset.primeProduct || 'Cube GPS tracker';
      drawer._primeLastFocus = trigger;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      savedStyles.set(drawer, { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight });
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.querySelector('[data-prime-cart-live]').textContent = (trigger.dataset.primeProduct || 'Product') + ' selected for Prime checkout.';
      requestAnimationFrame(() => drawer.querySelector(closeSelector)?.focus());
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (trigger) {
        event.preventDefault();
        openDrawer(trigger);
        return;
      }
      const close = event.target.closest(closeSelector);
      if (close) closeDrawer(close.closest('[data-prime-cart-drawer]'));
    });

    document.addEventListener('keydown', (event) => {
      const drawer = document.querySelector('[data-prime-cart-drawer].is-open');
      if (!drawer) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(drawer);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
